import { useEffect, useState } from "react";
import { WifiOff } from "lucide-react";
import { SITE } from "../lib/site";

// Gentle, non-blocking banner shown inside the vault when the browser loses its connection.
// Opened documents stay viewable from the PWA cache; this just sets expectations.
export const OfflineBanner = () => {
  const [offline, setOffline] = useState(typeof navigator !== "undefined" && navigator.onLine === false);

  useEffect(() => {
    const goOnline = () => setOffline(false);
    const goOffline = () => setOffline(true);
    window.addEventListener("online", goOnline);
    window.addEventListener("offline", goOffline);
    return () => {
      window.removeEventListener("online", goOnline);
      window.removeEventListener("offline", goOffline);
    };
  }, []);

  if (!offline) return null;

  return (
    <div
      data-testid="offline-banner"
      role="status"
      aria-live="polite"
      className="fixed top-[4.5rem] inset-x-0 z-[70] flex justify-center px-3 pointer-events-none animate-in fade-in slide-in-from-top-2 duration-300"
    >
      <div className="pointer-events-auto flex items-center gap-2.5 rounded-full border border-amber-300/70 bg-amber-50/95 dark:bg-amber-950/80 dark:border-amber-800/70 text-amber-900 dark:text-amber-200 px-4 py-2 shadow-lg backdrop-blur">
        <WifiOff className="h-4 w-4 shrink-0" />
        <span className="text-sm">You're offline — showing saved copies. Changes will sync when you're back online.</span>
        <a href={SITE.statusUrl} target="_blank" rel="noopener noreferrer" className="text-xs underline underline-offset-2 whitespace-nowrap" data-testid="offline-status-link">Is it us?</a>
      </div>
    </div>
  );
};
